/* eslint "no-underscore-dangle": "off" */

'use client';

import I18nContext from 'next-translate/context';
import transCore from 'next-translate/transCore';
import type { I18nProviderProps } from 'next-translate';
import { PropsWithChildren, useRef } from 'react';

type Props = PropsWithChildren<{
  lang: string;
  config: NonNullable<I18nProviderProps['config']>;
  namespaces: NonNullable<I18nProviderProps['namespaces']>;
}>;

export default function I18nProvider({
  children,
  lang,
  config,
  namespaces,
}: Props) {
  const value = useRef({
    lang,
    t: transCore({
      lang,
      config,
      allNamespaces: namespaces,
      pluralRules: new Intl.PluralRules()
    })
  });

  return (
    <I18nContext.Provider value={value.current}>
      {children}
    </I18nContext.Provider>
  );
}
